import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../src/store/index.js'), 'store/index.js')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../src/store/accounts.js'), 'accounts.js')
  resolveStoreModules(require('../src/store/analytics.js'), 'analytics.js')
  resolveStoreModules(require('../src/store/company.js'), 'company.js')
  resolveStoreModules(require('../src/store/dataViewer.js'), 'dataViewer.js')
  resolveStoreModules(require('../src/store/downloads.js'), 'downloads.js')
  resolveStoreModules(require('../src/store/experiments.js'), 'experiments.js')
  resolveStoreModules(require('../src/store/search.js'), 'search.js')
  resolveStoreModules(require('../src/store/tours.js'), 'tours.js')
  resolveStoreModules(require('../src/store/userCredits.js'), 'userCredits.js')
  resolveStoreModules(require('../src/store/userSubscriptions.js'), 'userSubscriptions.js')
  resolveStoreModules(require('../src/store/views.js'), 'views.js')
  resolveStoreModules(require('../src/store/zoho.js'), 'zoho.js')
  resolveStoreModules(require('../src/store/company/about.js'), 'company/about.js')
  resolveStoreModules(require('../src/store/company/importers.js'), 'company/importers.js')
  resolveStoreModules(require('../src/store/company/notes.js'), 'company/notes.js')
  resolveStoreModules(require('../src/store/company/overview.js'), 'company/overview.js')
  resolveStoreModules(require('../src/store/company/shipments.js'), 'company/shipments.js')
  resolveStoreModules(require('../src/store/company/suppliers.js'), 'company/suppliers.js')
  resolveStoreModules(require('../src/store/company/visualmap.js'), 'company/visualmap.js')
  resolveStoreModules(require('../src/store/search/aggregatedConsignees.js'), 'search/aggregatedConsignees.js')
  resolveStoreModules(require('../src/store/search/aggregatedShippers.js'), 'search/aggregatedShippers.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const storeModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(storeModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
